export default __webpack_public_path__ + "d023e87cf8a3bc5a67776d05975f26dd.svg";